export const calculatePercentage = (step: number, stepWidth: number) => {
  const width = Math.trunc(stepWidth * step)
  return `${width}%`
}
